import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import Breadcrumb from "../../components/navigation/Bredcrumbs";
import TopHeadding from "../../components/layout/TopHeadding";
import StatusPopup from "../../components/popups/StatusPopup";
import PendingPayrollTable from "../../components/tables/PendingPayrollTable";

import { fetchPendingPayrollPayments } from "../../store/slices/payrollSlice";

const DASHBOARD_KEY = "pendingPayrollPayments";

const PendingPayrollPayments = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const [pageIndex, setPageIndex] = useState(1);
    const pageSize = 10;

    const { role } = useSelector((s) => s.user);

    const data = useSelector(
        (s) => s.payroll.listDataByKey[DASHBOARD_KEY] || []
    );

    const totalRecords = useSelector(
        (s) => s.payroll.totalByKey[DASHBOARD_KEY] || 0
    );

    const loading = useSelector(
        (s) => s.payroll.listLoadingByKey[DASHBOARD_KEY]
    );

    const error = useSelector(
        (s) => s.payroll.entityErrorByKey[DASHBOARD_KEY]
    );

    useEffect(() => {
        const params = {
            pageIndex: pageIndex - 1,
            pageSize
        };

        if (role === "Client") {
            params.clientId = id;
        } else if (role === "Company") {
            params.companyId = id;
        }

        dispatch(
            fetchPendingPayrollPayments({
                key: DASHBOARD_KEY,
                params
            })
        );
    }, [pageIndex, dispatch, id, role]);

    return (
        <div className="pending_payments">
            <Breadcrumb
                items={[
                    { label: "Dashboard", link: "/" },
                    { label: "Pending Payments", active: true }
                ]}
            />

            <TopHeadding
                title="Pending Payments"
                subtitle="Payroll batches awaiting payment"
            />

            <div className="container-fluid mt_20">
                <PendingPayrollTable
                    data={data || []}
                    loading={loading}
                    currentPage={pageIndex}
                    pageSize={pageSize}
                    totalRecords={totalRecords}
                    onPageChange={(page) => setPageIndex(page)}
                />
            </div>

            <StatusPopup
                show={!!error}
                type="error"
                message={error}
                handleClose={() => { }}
            />
        </div>
    );
};

export default PendingPayrollPayments;
